import React, { PureComponent, createElement } from "react";
import PropTypes from "prop-types";
import { Breadcrumb } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

export default class PageHeader extends PureComponent {
	static contextTypes = {
		routes: PropTypes.array,
		params: PropTypes.object,
		location: PropTypes.object,
		breadcrumbNameMap: PropTypes.object
	};
	getBreadcrumbProps = () => {
		return {
			routes: this.props.routes || this.context.routes,
			params: this.props.params || this.context.params,
			routerLocation: this.props.location || this.context.location,
			breadcrumbNameMap:
				this.props.breadcrumbNameMap || this.context.breadcrumbNameMap
		};
	};
	// Generated according to props
	conversionFromProps = () => {
		const {
			breadcrumbList,
			breadcrumbSeparator,
			linkElement = "a"
		} = this.props;
		return (
			<Breadcrumb className={styles.breadcrumb} separator={breadcrumbSeparator}>
				{breadcrumbList.map(item => (
					<Breadcrumb.Item key={item.title}>
						{item.href
							? createElement(
									linkElement,
									{
										[linkElement === "a" ? "href" : "to"]: item.href,
										target: item.target ? item.target : "_self"
									},
									item.title
							  )
							: item.title}
					</Breadcrumb.Item>
				))}
			</Breadcrumb>
		);
	};
	/**
	 * 将参数转化为面包屑
	 * Convert parameters into breadcrumbs
	 */
	conversionBreadcrumbList = () => {
		const { breadcrumbList, breadcrumbSeparator } = this.props;
		const {
			routes,
			params,
			routerLocation,
			breadcrumbNameMap
		} = this.getBreadcrumbProps();
		if (breadcrumbList && breadcrumbList.length) {
			return this.conversionFromProps();
		}

		return null;
	};
	// 渲染Breadcrumb 子节点
	// Render the Breadcrumb child node
	itemRender = (route, params, routes, paths) => {
		const { linkElement = "a" } = this.props;
		const last = routes.indexOf(route) === routes.length - 1;
		return last || !route.component ? (
			<span>{route.breadcrumbName}</span>
		) : (
			createElement(
				linkElement,
				{
					href: paths.join("/") || "/",
					to: paths.join("/") || "/"
				},
				route.breadcrumbName
			)
		);
	};

	render() {
		const {
			title,
			logo,
			action,
			content,
			extraContent,
			className
		} = this.props;
		const clsString = classNames(styles.pageHeader, className);

		const breadcrumb = this.conversionBreadcrumbList();

		return (
			<div className={clsString}>
				{breadcrumb}
				<div className={styles.detail}>
					{logo && <div className={styles.logo}>{logo}</div>}
					<div className={styles.main}>
						<div className={styles.row}>
							{title && <h1 className={styles.title}>{title}</h1>}
							{action && <div className={styles.action}>{action}</div>}
						</div>
						<div className={styles.row}>
							{content && <div className={styles.content}>{content}</div>}
							{extraContent && (
								<div className={styles.extraContent}>{extraContent}</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
